module.exports = __webpack_public_path__ + "8381adc8836e3efa9dc1106fdf15113f.svg";